import { Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";

export default function Footer() {
  const { d } = useI18n();
  const f = d.footer;
  const orgHrefs = ["/#mission", "/#roadmap", "/transparency", "/#join"];
  const initHrefs = ["/world-rhubarb-day", "/#market", "/#knowledge", "/#database"];
  const refLinks = [
    { name: "ISO — Structure", url: "https://www.iso.org/structure.html" },
    { name: "FAO — Ethics", url: "https://www.fao.org/ethics/policies/en" },
    { name: "IAIA — Transparency", url: "https://iaia.org/transparency/" },
    { name: "RHS — Rhubarb", url: "https://www.rhs.org.uk/vegetables/rhubarb/grow-your-own" },
  ];

  return (
    <footer className="border-t border-border bg-card/40" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 py-16 sm:px-10 lg:px-16">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center border border-foreground/30 font-serif text-lg italic">R</span>
              <span className="font-mono text-[10px] uppercase leading-tight tracking-[0.3em]">
                {d.nav.brandTop}
                <br />
                {d.nav.brandBottom}
              </span>
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-muted-foreground">{f.tagline}</p>
            <div className="mt-6 space-y-1.5 font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground" data-testid="footer-honesty-ledger">
              {f.ledger.map((l) => (
                <p key={l}>{l}</p>
              ))}
            </div>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-crimson dark:text-stalk">{f.orgTitle}</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              {f.orgLinks.map((label, i) => (
                <li key={label}>
                  {orgHrefs[i].startsWith("/") && !orgHrefs[i].startsWith("/#") ? (
                    <Link to={orgHrefs[i]} data-testid={i === 2 ? "footer-transparency-link" : undefined} className="u-link text-foreground/80 hover:text-foreground">{label}</Link>
                  ) : (
                    <a href={orgHrefs[i]} className="u-link text-foreground/80 hover:text-foreground">{label}</a>
                  )}
                </li>
              ))}
              <li>
                <Link to="/privacy" data-testid="footer-privacy-link" className="u-link text-foreground/80 hover:text-foreground">{f.privacy}</Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-crimson dark:text-stalk">{f.initTitle}</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              {f.initLinks.map((label, i) => (
                <li key={label}>
                  {initHrefs[i].startsWith("/") && !initHrefs[i].startsWith("/#") ? (
                    <Link to={initHrefs[i]} data-testid={i === 0 ? "footer-wrd-link" : undefined} className="u-link text-foreground/80 hover:text-foreground">{label}</Link>
                  ) : (
                    <a href={initHrefs[i]} className="u-link text-foreground/80 hover:text-foreground">{label}</a>
                  )}
                </li>
              ))}
              <li>
                <Link to="/database-survey" data-testid="footer-survey-link" className="u-link text-foreground/80 hover:text-foreground">{d.survey.title}</Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-crimson dark:text-stalk">{f.refTitle}</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              {refLinks.map((r) => (
                <li key={r.url}>
                  <a href={r.url} target="_blank" rel="noreferrer" className="u-link text-foreground/80 hover:text-foreground">{r.name}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-border pt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <p>{f.copyright}</p>
          <p>{f.verified}</p>
        </div>
      </div>
    </footer>
  );
}
